import { render, staticRenderFns } from "./AggStatus.vue?vue&type=template&id=a5bc414a&"
import script from "./AggStatus.vue?vue&type=script&lang=js&"
export * from "./AggStatus.vue?vue&type=script&lang=js&"
import style0 from "./AggStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QColor});
